import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/expeditedssl': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 43.4c117.4 0 212.6 95.2 212.6 212.6s-95.2 212.6-212.6 212.6-212.6-95.2-212.6-212.6 95.2-212.6 212.6-212.6zM150.6 176.3h-0.2v26.6c0 5 3.9 8.9 8.9 8.9h17.7c5 0 8.9-3.9 8.9-8.9v-26.6c0-82.1 124-82.1 124 0v26.6c0 5 3.9 8.9 8.9 8.9h17.7c5 0 8.9-3.9 8.9-8.9v-26.6c0-53.7-43.7-97.4-97.4-97.4s-97.4 43.7-97.4 97.4zM389.7 380v-141.7c0-9.7-8-17.7-17.7-17.7h-248c-9.7 0-17.7 8-17.7 17.7v141.7c0 9.7 8 17.7 17.7 17.7h248c9.7 0 17.7-8 17.7-17.7zM141.7 242.7v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4v-132.9c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zM283.4 291.4c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4 19.6 0 35.5 15.8 35.5 35.4zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 486.3c127 0 230.3-103.3 230.3-230.3s-103.3-230.3-230.3-230.3-230.3 103.3-230.3 230.3 103.3 230.3 230.3 230.3z'
      }
    ]
  }
})
